import React, {useState} from "react";
import { makeStyles } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { Slide } from "@material-ui/core";
import { ButtonContainer, StyledButton } from "./GlobalModalV2Style";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function GlobalModalV2 (props)  {
    
    const classes = useStyles();
    const modalBodyId = props.bodyId ? props.bodyId : 'modal___body___container___id';

    const [show, setShow] = useState(props.open)

    const closeModal=()=>{
        setShow(false);
        setTimeout(()=>{
            props.onClose(false)
        },500)
    }

    let extra_props = {}
    if(props.extra_props_active !== undefined){
        extra_props['disableEnforceFocus'] = true;
        extra_props['disableAutoFocus'] = true;
    }

    const handleOnScroll = () => {
        if(props.handleOnScroll !== undefined){
            props.handleOnScroll()
        }
    }

    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={show}
                onClose={props.setOpenSMSModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 1000,
                }}
                onBackdropClick ={closeModal}
                ModalProps={{
                    disableEnforceFocus: true,
                    disableAutoFocus: true,
                }}
                {...extra_props}
            >
                <Slide in={show} direction="left">
                    <div className={`globalModalWrapper cardBordcastTab ${props.className !== undefined ? props.className : ''} ${props.hideFooter !== true ? '': 'global-modal-has-no-footer' }`} >
                        <div id="globalModal">
                            <div className="globalModalTitle d-flex justify-content-between align-items-center">
                                <div className="sub_title">
                                    {
                                        typeof props.title === 'string' ? 
                                        <h2>{props.title}</h2> : 
                                        <>{props.title}</>
                                    }
                                    
                                </div>
                                {typeof props.extraButton != 'undefined' &&
                                <div className="extra-button" onClick={props.onClickExtraButton}>
                                    {props.extraButton}
                                </div>
                                }
                            </div>

                            {/* Modal Body */}

                            <div className="modalBody" style={{position: "relative"}} id={modalBodyId} onScroll={handleOnScroll}>
                              {props.children}
                            </div>
                            
                            {/*Send Massage and close button*/}
                            {
                                props.hideFooter !== true && (
                                    <ButtonContainer>
                                        <StyledButton
                                            className="secondary"
                                            onClick={closeModal}
                                            type="button"
                                        >
                                            Cancel
                                        </StyledButton>
                                        <StyledButton
                                            className="primary"
                                            onClick={props.handleSubmit} 
                                            type="submit"
                                        >
                                            {props.buttonText}
                                        </StyledButton>
                                    </ButtonContainer>
                                )
                            }
                            
                        </div>
                    </div>
                </Slide>
            </Modal>
        </>
    );
}